import { InformationCircleIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { useMediaQuery } from '@mantine/hooks'
import Image from 'next/image'
import { useState } from 'react'

interface IFlowItemProps {
  apply: {
    title: string
    frontDesc: string
    boldLabel: string
    backDesc: string
    imgUrl: string
    mobileImgUrl: string
    cautionToggle?: boolean
  }
  idx: number
}

const FlowItem = ({ apply, idx }: IFlowItemProps) => {
  const isMobile = useMediaQuery('(max-width:768px)')
  const [isToggleOpen, setIsToggleOpen] = useState(false)
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <p className="inline-flex h-5 w-5 items-center justify-center rounded bg-yellow-450 text-sm font-bold text-white">
          {idx + 1}
        </p>
        <p className="text-lg font-semibold">{apply.title}</p>
      </div>
      <p className="text-sm leading-[1.57] text-gray-500 md:mb-1 md:text-base">
        {apply.frontDesc} <span className="font-semibold">{apply.boldLabel} </span>
        {apply.backDesc}
      </p>
      {apply.cautionToggle && isMobile && (
        <div
          className="cursor-pointer rounded-xl bg-[#FEE] p-3"
          onClick={() => setIsToggleOpen(!isToggleOpen)}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <InformationCircleIcon className="h-5 w-5 text-red-450" />
              <p className="font-semibold text-red-450">빠르게 카드 발급하는 방법</p>
            </div>
            <ChevronDownIcon
              className={`${isToggleOpen ? 'rotate-180 transform' : ''} h-5 w-5 text-red-450`}
            />
          </div>
          {isToggleOpen && (
            <div className="mt-2 flex flex-col gap-2">
              <p className="text-sm text-gray-500">
                발급신청서 작성 시 <span className="font-semibold">신한카드</span>로 신청하면
                하루만에 카드를 발급 받을 수 있어요.
              </p>
              <p className="text-sm font-semibold text-red-450">
                * 카드발급(신청)방법 - 우편(모바일신청) 선택
              </p>
            </div>
          )}
        </div>
      )}
      <div className="overflow-hidden rounded-xl">
        <Image
          src={isMobile ? apply.mobileImgUrl : apply.imgUrl}
          alt={apply.title}
          width={720}
          height={506}
        />
      </div>
    </div>
  )
}

export default FlowItem
